<template>
<section>
    <div v-if="loading" class="content content-centered">
        <pulse-loader></pulse-loader>
    </div>
    <div v-show="!loading" class="content">
        <div class="box">
            <div class="box-body">
                <div class="row">
                    <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
                        <div class="alert" :class="'alert-' + flashType">
                            {{ flashMessage }}
                        </div>
                    </div>
                </div>
                <div id="details" class="row">
                    <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
                        <div class="col-sm-12">
                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.cityId)">
                                    <label>City</label>
                                    <select required name="cityId" class="form-control" :disabled="isCityDisable" v-model="dailyWages.cityId">
                                        <option value="" disabled>Select City Name</option>
                                        <option v-for="cityId in citys" :value="cityId.id">{{ cityId.name }}
                                        </option>
                                    </select>
                                    <field-messages name="cityId" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">This is required field</div>
                                    </field-messages>
                                </validate>
                            </div>
                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.expense)">
                                    <label>Expense</label>
                                    <input type="text" name="expense" maxlength="25" class="form-control" required v-model="dailyWages.expense" placeholder="Expense" pattern="^[a-zA-Z][a-zA-Z0-9\s]{0,25}" />
                                    <field-messages name="expense" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">
                                            Expense is a required field
                                        </div>
                                        <div slot="pattern">
                                           Only Alphabets/Numbers are allowed. (eg : xyz123)
                                        </div>
                                    </field-messages>
                                </validate>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.expenseType)">
                                    <label>Expense Type</label>
                                    <select required name="expenseType" class="form-control" v-model="dailyWages.expenseType">
                                        <option value="" disabled>Select Expense Type</option>
                                        <option v-for="expenseType in expenseTypee">{{ expenseType}}</option>
                                    </select>
                                    <field-messages name="expenseType" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">
                                            Expanse Type is a required field
                                        </div>
                                    </field-messages>
                                </validate>
                            </div>
                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.expenseDate)">
                                    <label for="dateAdded">Expense Date</label>
                                    <date-picker required id="vMakeYear" v-model="dailyWages.expenseDate" lang="en" min="0" :not-after="afterDisable" name="expenseDate" input-class="form-control" width="100%" use-utc="true" format="DD-MM-YYYY"></date-picker>
                                    <field-messages name="expenseDate" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">
                                            Expense Date is a required field
                                        </div>
                                        <div slot="pattern">expense date is invalid</div>
                                    </field-messages>
                                </validate>
                            </div>
                        </div>

                        <div class="col-sm-12">
                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.receipt)">
                                    <label>Receipt</label>
                                    <input type="file" id="fileName" accept="image/png,image/jpeg,image/jpg,application/pdf" name="receipt" required class="form-control" @change.prevent="onDocumentchanged" />
                                    <field-messages name="receipt" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">
                                            Please upload less than 5mb Receipt
                                        </div>
                                    </field-messages>
                                    <div class="border p-2 mt-3" v-if="$route.params && $route.params._id != '0'">
                                        <a v-bind:href="dailyWages.receipt" target="_blank">
                                            View
                                        </a>
                                    </div>
                                </validate>
                            </div>
                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.amount)">
                                    <label>Amount (INR)</label>
                                    <input  type="text" name="amount" class="form-control" required v-model="dailyWages.amount" placeholder="Amount" pattern="\d{0,10}" />
                                    <field-messages name="amount" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">Amount is a required field</div>
                                        <div slot="pattern">
                                            Numbers are allowed(Max limit 10 digits).
                                        </div>
                                    </field-messages>
                                </validate>
                            </div>
                        </div>
                    </vue-form>

                    <div class="col-sm-12 text-right">
                        <router-link :to="{ name: 'dailywages' }">
                            <button class="mr-5 btn btn-default" type="button">
                                Cancel
                            </button>
                        </router-link>
                        <button class="mr-2 btn gradientbt" type="submit" @click="createDailyWages" :disabled="!(formstate.$dirty && formstate.$valid && this.docs)" v-if="$route.params && $route.params._id == '0'">
                            Save
                        </button>
                        <button class="btn gradientbt mr-5" type="submit" @click="updateDailyWages" :disabled="
                  !((formstate.$dirty || isFileChange) && formstate.$valid)
                " v-if="$route.params && $route.params._id !='0'">
                            Update
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import axios from "axios";
import store from "../../../store";
import {
    formService,
    eventBus,
    dailyWagesService,
    fileService,
} from "../../../services";
import {
    EVENTS
} from "../../../config";
import {
    USER_ROLES
} from "../../../config";
import {
    mapState
} from "vuex";

export default {
    name: "dailywagescreate",
    changedFlag: "",
    data() {
        return {
            isCityDisable: false,
            afterDisable: new Date(),
            ready: false,
            isFileChange: false,
            USER_ROLES: USER_ROLES,
            loading: false,
            flash: false,
            flashType: null,
            flashMessage: "",
            EVENTS: EVENTS,
            formstate: {},
            dailyWages: {
                cityId: "",
                expenseType: "",
            },
            oldDailyWages: {},
            dailyWagesId: [],
            data: {},

            expenseTypee: ["Salary", "General Expenses"],
            docs: null,
            citys: {},
        };
    },
    mounted: function () {
        this.getCityList();
    },

    methods: {
        fieldClassName: formService.fieldClassName,

        getCityList() {
            if (this.$store.state.auth.user.role.key === "cityAdmin") {
                const {
                    _id,
                    cityName
                } = this.$store.state.auth.user.cityId;
                this.citys = [{
                    id: _id,
                    name: cityName
                }];
                this.dailyWages["cityId"] = _id;
                this.isCityDisable = true;
                return;
            }
            this.loading = true;
            const params = {};
            let cityList = [];
            this.$cityRepository
                .collectionCitysList(params)
                .then((res) => {
                    this.loading = false;
                    res.data.response.forEach((element) => {
                        if (element.status === true) {
                            cityList.push({
                                name: element.cityName,
                                id: element._id,
                            });
                        }
                    });

                    cityList.sort((item1, item2) => {
                        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                    });

                    this.citys = cityList;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("citys.requestFunction-error:", error);
                    this.$snotify.error("Get citys list failed", "Error!");
                });
        },

        getDailyWages() {
            const params = {};

            return dailyWagesService
                .getById(this.$route.params._id)
                .then((response) => {
                    let data = [];
                    data = response.data.response;
                    data["cityId"] = response.data.response.cityId._id;
                    this.dailyWages = data;
                    this.oldDailyWages = _.cloneDeep(this.dailyWages);
                })
                .catch((error) => {
                    console.error("Fuel Expenses-error:", error);
                    this.$snotify.error("Get Fuel Expenses failed", "Error!");
                });
        },
        onDocumentchanged(event) {
            const fileName = document.getElementById("fileName");

            if (
                ["image/png", "image/jpeg", "image/jpg", "application/pdf"].includes(
                    event.target.files[0]["type"]
                )
            ) {
                if (event.target.files[0].size > 1024 * 1024 * 5) {
                    this.$snotify.error("File Size max limit of 5 MB", "Error!");
                    fileName.value = "";
                    event.preventDefault();
                    // event.stopPropagation();
                    return;
                } else {
                    this.docs = event.target.files[0];
                    if (this.$route.params && this.$route.params._id != '0') {
                        this.changedFlag = true;
                    }

                    if (this.docs) {
                        this.isFileChange = true;
                    } else {
                        this.isFileChange = false;
                    }
                }
            } else {
                this.$snotify.error("Upload .png, .jpeg, .jpg, .pdf files", "Error!");
                fileName.value = "";
            }
        },

        async uploadDocument() {
            let docsArr = [];

            docsArr.push(this.docs);

            const response = await fileService.fileUpload(docsArr, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return response.data;
        },

        async createDailyWages() {
            this.loading = true;

            let uploadedFileLocation = await this.uploadDocument();
            if (uploadedFileLocation !== "") {
                this.dailyWages.receipt = uploadedFileLocation[0].Location;
            }
            return dailyWagesService
                .addDailyWages(this.dailyWages)
                .then((response) => {
                    this.loading = false;
                    this.flash = false;
                    this.$snotify.success(`The Daily Wages has been added successfully.`);
                    let docId = response._id;
                    this.uploadDocument(docId);
                    this.$router.push("/dailywages");
                })
                .catch((error) => {
                    this.loading = false;
                    this.$snotify.error(error, "Error!");
                });
        },

        clearChanges() {
            this.dailyWages = _.cloneDeep(this.oldDailyWages);
            this.formstate._reset();
        },
        async updateDailyWages() {
            const id = this.$route.params._id;
            this.loading = true;
            this.data = {};
            this.data["cityId"] = this.dailyWages["cityId"];
            this.data["expense"] = this.dailyWages["expense"];
            this.data["expenseDate"] = this.dailyWages["expenseDate"];
            this.data["expenseType"] = this.dailyWages["expenseType"];
            this.data["amount"] = this.dailyWages["amount"];
            // this.data["receipt"] = this.dailyWages["receipt"];
            this.data["_id"] = this.$route.params._id;
            if (this.docs != null) {
                let uploadedFileLocation = await this.uploadDocument();
                if (uploadedFileLocation !== "") {
                    this.data["receipt"] = uploadedFileLocation[0].Location;
                }
            } else {
                this.data["receipt"] = this.dailyWages["receipt"];
            }

            return dailyWagesService
                .updateDailyWages(id, this.data)
                .then((response) => {
                    this.loading = false;
                    this.flash = false;
                    this.formstate._reset();
                    this.oldDailyWages = _.cloneDeep(this.dailyWages);
                    this.$snotify.success(
                        `The Daily Wages has been updated successfully.`
                    );
                    this.$router.push("/dailywages");
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("Fuel Expenses.Update Daily Wages-error:", error);
                    this.$snotify.error("Update Daily Wages failed", "Error!");
                    if (error.data.message.includes("must be one of")) {
                        this.flash = true;
                        this.flashType = "error";
                        this.flashMessage =
                            "That fuelExpenses name is not allowed. You must first update the list of allowed fuelExpenses names" +
                            " in the appy client and server config.";
                    }
                });
        },
    },
    created() {
        const promises = [];
        this.loading = true;
        // promises.push(this.getFuelExpenses());
        if (this.$route.params && this.$route.params._id && this.$route.params._id != '0') {
            promises.push(this.getDailyWages());
        }
        Promise.all(promises)
            .then(() => {
                this.loading = false;
                this.ready = true;
            })
            .catch(() => {
                this.loading = false;
            });
    },
    beforeDestroy() {},

    fieldClassName: function (field) {
        if (!field) {
            return "";
        }
        if ((field.$touched || field.$submitted) && field.$valid) {
            return "has-success";
        }
        if ((field.$touched || field.$submitted) && field.$invalid) {
            return "has-danger";
        }
    },
    // computed: {
    //     sortedItems() {
    //         return this.citys;
    //     },
    // },

    // computed: {
    //     ...mapState({
    //         user: state => state.auth.user,
    //     })
    // }
};
</script>

<style scoped>
.required-field>label::after {
    content: "*";
    color: red;
    margin-left: 0.25rem;
}

.form-control-feedback {
    font-weight: 100;
    color: red;
    position: initial;
    text-align: left;
    height: auto;
    width: auto;
}

.has-danger {
    color: red;
}

.mt {
    margin-top: 7px;
}

.gradientbt {
    background: #0f6940;
    color: white;
}

.inputwrapper {
    position: relative;
}

.maps {
    position: absolute;
    top: 7px;
    right: 10px;
}
</style>



// WEBPACK FOOTER //
// dailyWagesCreate.vue?1092d3f9